import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CLINIC } from "@/lib/site";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth-login.php", { email, password });
      localStorage.setItem("ff_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full h-12 px-4 bg-background border border-input rounded-sm text-sm text-foreground placeholder:text-muted-foreground focus:border-accent transition-colors";

  return (
    <div className="min-h-screen grid place-items-center bg-background px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm flat-card p-8 md:p-10">
        <div className="flex items-center gap-3">
          <img src={CLINIC.logo} alt="FizioFit Logo" className="h-10 w-auto object-contain" />
          <div className="h-9 w-9 grid place-items-center rounded-sm bg-foreground text-primary-foreground ml-auto">
            <Lock size={16} />
          </div>
        </div>
        <h1 className="mt-6 text-2xl font-light tracking-tight text-foreground">Paneli Admin</h1>
        <p className="mt-1 text-sm text-muted-foreground">FizioFit Center · Rezervimet</p>

        <div className="mt-8 space-y-4">
          <div>
            <label className="text-xs text-muted-foreground mb-2 block">Email</label>
            <input data-testid="admin-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@fiziofit.al" />
          </div>
          <div>
            <label className="text-xs text-muted-foreground mb-2 block">Fjalëkalimi</label>
            <input data-testid="admin-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
        </div>

        {error && <p data-testid="admin-error" className="mt-4 text-sm text-destructive">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 h-12 rounded-sm bg-accent text-white text-sm font-medium hover:bg-accent/90 shadow-md shadow-accent/25 transition-all disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : null}
          {loading ? "Duke hyrë..." : "Hyr"}
        </button>
      </form>
    </div>
  );
}
